import { List, useDataGrid } from "@refinedev/mui";
import React from "react";

import { IPost } from "./interfaces";
import { SearchToolbar, DataGridPanel, ListPageHeader } from "components/list";
import { postsColumns } from "./components/postsColumns";
import { postsSearchFields } from "./components/postsSearchFields";

export const PostList: React.FC = () => {
    const { dataGridProps, setFilters, filters, tableQueryResult } =
        useDataGrid<IPost>({
            initialCurrent: 1,
            initialPageSize: 20,
            sorters: {
                initial: [{ field: "id", order: "desc" }],
            },
        });

    // refine의 rowCount는 fetch 중 잠깐 0으로 떨어져 "전체 0건"이 깜빡인다.
    // 로딩이 아닐 때의 마지막 값을 유지해 표시한다.
    const lastRowCountRef = React.useRef<number | undefined>(undefined);
    if (!dataGridProps.loading && typeof dataGridProps.rowCount === "number") {
        lastRowCountRef.current = dataGridProps.rowCount;
    }

    return (
        <List breadcrumb={<></>}>
            <ListPageHeader
                count={lastRowCountRef.current}
                description="시설 게시판에 등록된 게시글 목록"
            />

            <SearchToolbar
                fields={postsSearchFields}
                filters={filters}
                setFilters={setFilters}
            />

            <DataGridPanel
                {...dataGridProps}
                columns={postsColumns}
                isError={tableQueryResult.isError}
                errorMessage="게시글 목록을 불러오지 못했습니다."
                emptyMessage="조건에 맞는 게시글이 없습니다."
                pageSizeOptions={[10, 20, 30, 50, 100]}
                disableColumnFilter
                filterModel={undefined}
                getRowShowPath={(row) => `/posts/show/${row.id}`}
            />
        </List>
    );
};
